import log from 'loglevel';

const PROJECT_PREFIX = '[EDGE]';

class LoggerFactory {
  private scope = 'Unknown Scope';

  private defaultLevel = process.env.REACT_APP_ENVIRONMENT === 'prod' ? log.levels.ERROR :
    log.levels.TRACE;

  public create(scope: string): log.Logger {
    this.scope = scope;
    const scopedLogger = log.getLogger(scope);
    scopedLogger.setLevel(this.defaultLevel);
    return scopedLogger;
  }

  public format(...args: unknown[]): string {
    const timestamp = new Date().toISOString();
    const prefix = `${PROJECT_PREFIX} - ${timestamp} ${this.scope}:`;

    const formattedArgs = args.map((arg) => {
      if (typeof arg === 'object' && arg !== null) {
        try {
          return JSON.stringify(arg, null, 2);
        } catch {
          return '[Unserializable Object]';
        }
      }
      return String(arg);
    });

    return `${prefix} ${formattedArgs.join(' ')}`;
  }
}

export const Logger = new LoggerFactory();
